// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var footerInner = "footer-module--footerInner--msBAL";
export var nav = "footer-module--nav--1TBHS";